import { render, staticRenderFns } from "./DirectAccessDialog.vue?vue&type=template&id=05ced749&"
import script from "./DirectAccessDialog.vue?vue&type=script&lang=ts&"
export * from "./DirectAccessDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DirectAccessDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports